import Vue from 'vue'
import folderApi from '../../api/admin/folder'
import router from '../../router'

export const state = () => ({
  folders: [],
  detailFolder: {},
  metadata: {},
  errorName: '',
  detailFile: {},
  errorFile: {},
  logFiles: {},
  progressValue: 0,
  showProgressBar: false,
  listTags: [],
  editFileDetail: {},
  folderSearch: [],
  listAuthor: [],
  folderBranches: [],
  folderMove: [],
  metadataMove: {},
  loading: true
})

export const getters = {

}
export const mutations = {
  CHANGE_FOLDERS (state, slug) {
    state.folders = []
    if (slug.folders && !slug.files) {
      state.folders = [ ...slug.folders ]
    } else if (slug.files && !slug.folders) {
      state.folders = [ ...slug.files ]
    } else if (slug.files && slug.folders) {
      state.folders = [ ...slug.folders, ...slug.files ]
    } else {
      state.folders = []
    }
  },
  CHANGE_FOLDER_SEARCH_LIST (state, slug) {
    if (slug.page_index !== 1) {
      state.folders = [...state.folders, ...slug.data]
    } else {
      state.folders = []
      state.folders = [...slug.data]
    }
  },
  CHANGE_FOLDER_NULL (state, slug) {
    state.folders = []
  },
  CHANGE_FOLDER_MOVE (state, slug) {
    state.folderMove = [...slug]
  },
  CHANGE_METADATA_MOVE (state, slug) {
    state.metadataMove = {...slug}
  },
  CHANGE_METADATA (state, slug) {
    state.metadata = { ...slug }
  },
  CHANGE_ERROR_NAME (state, slug) {
    state.errorName = slug
  },
  CHANGE_DETAIL_FOLDER (state, slug) {
    state.detailFolder = { ...slug }
  },
  CHANGE_DETAIL_FILE (state, slug) {
    state.detailFile = { ...slug }
  },
  CHANGE_DETAIL_FILE_EDIT_TAG (state, slug) {
    state.editFileDetail = { ...slug }
  },
  CHANGE_UPDATE_FOLDER (state, slug) {
    if (state.folders) {
      const tmpFolder = [...state.folders]
      const index = tmpFolder.findIndex(u => u.id === slug.id)
      Object.assign(tmpFolder[index], { ...slug })
      state.folders = tmpFolder
    }
  },
  CHANGE_DETAIL_FILE_EDIT (state, slug) {
    const tmpDetailFile = {...state.detailFile}
    const tmpTags = [...tmpDetailFile.tags]
    tmpTags.push(slug)
    tmpDetailFile.tags = tmpTags
    state.detailFile = tmpDetailFile
  },
  CHANGE_ERROR_FILE (state, slug) {
    state.errorFile = { ...slug }
  },
  CHANGE_LOG_FILE (state, slug) {
    state.logFiles = { ...slug }
  },
  CHANGE_VALUE_PROGRESSBAR (state, slug) {
    state.progressValue = slug
  },
  CHANGE_SHOW_PROGRESSBAR (state, slug) {
    state.showProgressBar = slug
  },
  CHANGE_LIST_TAG (state, slug) {
    state.listTags = [...slug]
  },
  CHANGE_FOLDER_SEARCH (state, slug) {
    state.folderSearch = [...slug]
  },
  CHANGE_AUTHOR (state, slug) {
    state.listAuthor = [...slug]
  },
  CHANGE_FOLDER_BRANCHES (state, slug) {
    if (state.folderBranches) {
      state.folderBranches = [...state.folderBranches, ...slug]
    }
  },
  CHANGE_LOADING (state, slug) {
    state.loading = slug
  }
}

export const actions = {
  async getFolder ({commit}, params) {
    commit('CHANGE_LOADING', true)
    try {
      const res = await folderApi.getFolder(params)
      if (res.status === 200) {
        commit('CHANGE_METADATA', res.data.metadata)
        commit('CHANGE_FOLDERS', {folders: res.data.data.folders, files: res.data.data.attachment_files, pageIndex: params.page_index})
        commit('CHANGE_LOADING', false)
      }
    } catch (error) {

    }
  },
  async getFolderMove ({commit}, params) {
    try {
      const res = await folderApi.getShowBranches(params)
      if (res.status === 200) {
        commit('CHANGE_METADATA_MOVE', res.data.metadata)
        commit('CHANGE_FOLDER_MOVE', res.data.data)
      }
    } catch (error) {

    }
  },
  async addFolder ({commit}, params) {
    try {
      const res = await folderApi.addFolder({...params, modal: undefined, clear: undefined, back: undefined})
      if (res.status === 201) {
        commit('CHANGE_FOLDER_NULL')
        params.modal()
        commit('CHANGE_LOADING', true)
        const resData = await folderApi.getFolder({page_index: 1, folder_parent_id: params.folder_parent_id, company_id: params.company_id})
        if (resData.status === 200) {
          commit('CHANGE_METADATA', resData.data.metadata)
          commit('CHANGE_FOLDERS', {folders: resData.data.data.folders, files: resData.data.data.attachment_files, pageIndex: 1})
        }
        params.back()
        params.clear()
        commit('CHANGE_LOADING', false)
      }
    } catch (error) {
      commit('CHANGE_ERROR_NAME', error.response.data.error.name)
    }
  },
  async detailFolder ({commit}, params) {
    try {
      const res = await folderApi.detailFolder(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_FOLDER', res.data.data)
      }
    } catch (error) {

    }
  },
  async updateFolder ({commit}, params) {
    try {
      const res = await folderApi.updateFolder(params)
      if (res.status === 201) {
        commit('CHANGE_UPDATE_FOLDER', res.data.data)
        params.modal()
      }
    } catch (error) {
      commit('CHANGE_ERROR_NAME', error.response.data.error.name)
    }
  },
  async deleteFolder ({commit}, params) {
    try {
      const res = await folderApi.deleteFolder({...params, modal: undefined, back: undefined})
      if (res.status === 204) {
        commit('CHANGE_FOLDER_NULL')
        commit('CHANGE_LOADING', true)
        params.back()
        params.modal()
        const resList = await folderApi.getFolder({page_index: 1, folder_parent_id: params.folder_parent_id, company_id: params.company_id})
        if (resList.status === 200) {
          commit('CHANGE_METADATA', resList.data.metadata)
          commit('CHANGE_FOLDERS', {folders: resList.data.data.folders, files: resList.data.data.attachment_files, pageIndex: 1})
        }
        commit('CHANGE_LOADING', false)
      }
    } catch (error) {

    }
  },
  async uploadChunk ({commit, state}, params) {
    const res = await folderApi.uploadChunk(params.formData)
    if (res.status === 201) {
      params.callback(res.data.filename)
    }
  },
  async checkUpload ({commit, state}, params) {
    const res = await folderApi.checkUpload(params.id)
    if (res.status === 200) {
      params.callback(res.data.data)
      if (res.data.data.status === 201) {
        commit('CHANGE_VALUE_PROGRESSBAR', 100)
        params.back()
        commit('CHANGE_FOLDER_NULL')
        commit('CHANGE_LOADING', true)
        params.modal()
        const resList = await folderApi.getFolder({page_index: 1, folder_parent_id: params.folder_parent_id, company_id: params.company_id})
        if (resList.status === 200) {
          commit('CHANGE_METADATA', resList.data.metadata)
          commit('CHANGE_FOLDERS', {folders: resList.data.data.folders, files: resList.data.data.attachment_files, pageIndex: 1})
        }
        params.clear()
        commit('CHANGE_SHOW_PROGRESSBAR', false)
        commit('CHANGE_VALUE_PROGRESSBAR', 0)
        commit('CHANGE_LOADING', false)
      }
    }
  },
  async addFile ({commit, state}, params) {
    let interval
    try {
      commit('CHANGE_SHOW_PROGRESSBAR', true)
      let i = 0
      interval = setInterval(() => {
        if (parseInt(i) < 99) {
          commit('CHANGE_VALUE_PROGRESSBAR', parseInt(i) + 1)
          i = i + 1
        }
      }, 100)
      const res = await folderApi.addFile(params.formData)
      if (res.status === 201) {
        clearInterval(interval)
        commit('CHANGE_VALUE_PROGRESSBAR', 100)
        params.back()
        commit('CHANGE_FOLDER_NULL')
        commit('CHANGE_LOADING', true)
        params.modal()
        const resList = await folderApi.getFolder({page_index: 1, folder_parent_id: params.folder_parent_id, company_id: params.company_id})
        if (resList.status === 200) {
          commit('CHANGE_METADATA', resList.data.metadata)
          commit('CHANGE_FOLDERS', {folders: resList.data.data.folders, files: resList.data.data.attachment_files, pageIndex: 1})
        }
        params.clear()
        commit('CHANGE_SHOW_PROGRESSBAR', false)
        commit('CHANGE_VALUE_PROGRESSBAR', 0)
        commit('CHANGE_LOADING', false)
      }
      params.callback(res.data)
    } catch (error) {
      clearInterval(interval)
      commit('CHANGE_SHOW_PROGRESSBAR', false)
      if (error.response.status === 400) {
        commit('CHANGE_VALUE_PROGRESSBAR', 0)
        commit('CHANGE_ERROR_NAME', error.response.data.error.name)
      }
      if (error.response.status === 500) {
        commit('CHANGE_VALUE_PROGRESSBAR', 0)
      }
    }
  },
  async detailFile ({commit}, params) {
    try {
      const res = await folderApi.detailFile(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_FILE', res.data.data)
        commit('CHANGE_DETAIL_FILE_EDIT_TAG', res.data.data)
      }
    } catch (error) {

    }
  },
  async logFile ({commit}, params) {
    try {
      const res = await folderApi.logFile(params)
      if (res.status === 200) {
        commit('CHANGE_LOG_FILE', res.data.data)
      }
    } catch (error) {

    }
  },
  async updateFile ({commit, state}, params) {
    try {
      const res = await folderApi.updateFile(params.formData, params.id)
      if (res.status === 201) {
        if (state.folders.length !== 0) {
          commit('CHANGE_UPDATE_FOLDER', res.data.data)
        }
        commit('CHANGE_DETAIL_FILE_EDIT_TAG', res.data.data)
        params.modal.hide()
      }
    } catch (error) {
      if (error.response.status === 400) {
        commit('CHANGE_ERROR_NAME', error.response.data.error.name)
      }
    }
  },
  async deleteFile ({commit}, params) {
    try {
      const res = await folderApi.deleteFile(params)
      if (res.status === 204) {
        if (params.folder_parent) {
          if (params.tab) {
            router.push({
              path: `/admin/companies/${params.company_id}/items/${params.folder_parent}`,
              query: {tab: params.tab}
            })
          } else {
            router.push(`/admin/companies/${params.company_id}/items/${params.folder_parent}`)
          }
        } else {
          params.back()
          params.load()
        }
        params.modal.hide()
      }
    } catch (error) {

    }
  },
  async moveFile ({commit}, params) {
    try {
      const res = await folderApi.updateFile({...params, modal: undefined, back: undefined, load: undefined, show: undefined, showFailure: undefined})
      if (res.status === 201) {
        params.modal()
        params.back()
        params.load()
        params.show()
      }
    } catch (error) {
      if (error.response.status === 400) {
        params.showFailure()
      }
    }
  },
  async copyFile ({commit}, params) {
    try {
      const res = await folderApi.copyFile({...params, back: undefined, load: undefined})
      if (res.status === 201) {
        params.back()
        params.load()
      }
    } catch (error) {

    }
  },
  async getTag ({commit}, params) {
    try {
      const res = await folderApi.getTag(params)
      if (res.status === 200) {
        commit('CHANGE_LIST_TAG', res.data.data)
      }
    } catch (error) {
    }
  },
  async getAuthor ({commit}, params) {
    try {
      const res = await folderApi.getAuthor(params)
      if (res.status === 200) {
        commit('CHANGE_AUTHOR', res.data.data)
      }
    } catch (error) {
    }
  },
  async getFolderSearch ({commit}, params) {
    try {
      const res = await folderApi.getFolderSearch(params)
      if (res.status === 200) {
        commit('CHANGE_FOLDER_SEARCH', res.data.data)
      }
    } catch (error) {
    }
  },
  async searchFile ({commit}, params) {
    commit('CHANGE_LOADING', true)
    try {
      const res = await folderApi.searchFile(params)
      if (res.status === 200) {
        commit('CHANGE_METADATA', res.data.metadata)
        commit('CHANGE_FOLDER_SEARCH_LIST', {data: res.data.data, page_index: params.page_index})
      }
      commit('CHANGE_LOADING', false)
    } catch (error) {
    }
  },
  async mergeVideos ({commit}, params) {
    let vm = new Vue()
    try {
      const res = await folderApi.mergeVideos(params)
      if (res.status === 200) {}
    } catch (error) {
      vm.$toastr.e('何かが間違っていました。もう一度やり直してください')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/folder.js